export const FETCH_TLOG_DATA_REQUEST = "FETCH_TLOG_DATA_REQUEST";
export const FETCH_TLOG_DATA_SUCCESS = "FETCH_TLOG_DATA_SUCCESS";
export const FETCH_TLOG_DATA_FAILURE = "FETCH_TLOG_DATA_FAILURE";
export const FETCH_TLOG_DATA_SAGA = "FETCH_TLOG_DATA_SAGA";
